/* eslint-disable */
import { compose } from 'lodash/fp'
import React, { useEffect, useRef } from 'react'
import Flex from 'typescript-styled-flex'
import { useSelector } from 'react-redux'
import { Textarea } from '../elements'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import { getReservationFormVeryCurrentTab } from '../../../reducers/bookingCalendar/selectors/reservationForm'
import changeWithMaxLength from './changeWithMaxLength'
import MaxLength from './MaxLength'
import withRedux from './withRedux'

const TextareaInput = FormElement(
  ({
     name,
     placeholder,
     isSelected,
     errorMsg,
     warningMsg,
     size = 1,
     minHeight,
     onChange,
     onBlur,
     onFocus,
     autoSize = false,
     value,
     disabled,
     onClick,
     maxLength,
     wrapperClick,
     style,
     className,
     rows,
     autoSizeMaxHeight = 242,
   }: ITextareaInputProps) => {
    const ref = useRef(null as HTMLTextAreaElement)
    const tab = useSelector(getReservationFormVeryCurrentTab)

    let v = value
    if (value === undefined || value === null) {
      v = ''
    }

    useEffect(() => {
      function OnInput() {
        this.style.height = 'auto'
        this.style.height = `${this.scrollHeight}px`
        this.style.overflowY = this.scrollHeight > autoSizeMaxHeight ? 'scroll' : 'hidden'
      }

      if (ref && ref.current && autoSize) {
        let tx = ref.current

        tx.style.height = `${tx.scrollHeight}px`

        tx.setAttribute(
          'style',
          `height:${tx.scrollHeight}px;overflow-y:${
            tx.scrollHeight > autoSizeMaxHeight ? 'scroll' : 'hidden'
          };`,
        )
        tx.addEventListener('input', OnInput, false)
      }
      return () => {
        if (ref && ref.current && autoSize) {
          ref.current.removeEventListener('input', OnInput)
        }
      }
    }, [ref.current, tab, autoSize, value])

    return (
      <Flex column={true} style={{ height: `auto` }}>
        <Textarea
          ref={ref}
          name={name}
          rows={rows}
          autoSize={autoSize}
          placeholder={placeholder}
          selected={isSelected}
          disabled={disabled}
          onClick={onClick}
          onBlur={onBlur}
          onFocus={onFocus}
          error={errorMsg && errorMsg !== ''}
          warning={warningMsg && warningMsg !== ''}
          minHeight={minHeight}
          value={v}
          size={size}
          autoSizeMaxHeight={autoSizeMaxHeight}
          onChange={changeWithMaxLength(maxLength)(onChange)}
          style={style}
          className={className}
        />

        {maxLength > 0 && (
          <Flex alignCenter={true} justifyEnd={true}>
            <MaxLength max={v.length === maxLength}>
              {v.length} / {maxLength}
            </MaxLength>
          </Flex>
        )}
      </Flex>
    )
  },
)

const ReduxField: React.ComponentType<ITextareaInputProps> = compose(
  withReduxForm,
  withRedux,
)(TextareaInput)

export default ReduxField
export { TextareaInput }

export interface ITextareaInputProps extends IFormElementProps {
  minHeight?: number
  autoSize?: boolean
  autoSizeMaxHeight?: number
  maxLength?: number
  rows?: number
}
